export default "__VITE_ASSET__fwYgEdhq__"